import { render } from "./HelpMain.vue?vue&type=template&id=1fda62e5"
import script from "./HelpMain.vue?vue&type=script&lang=js"
export * from "./HelpMain.vue?vue&type=script&lang=js"

import "./HelpMain.vue?vue&type=style&index=0&id=1fda62e5&lang=css"

import exportComponent from "/home/Daten/Entwicklung/repositories/bdl_ui/de.stone.bdl.management.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__